// extracted by mini-css-extract-plugin
module.exports = {"tableHead":"Table_tableHead__u2Y-h","bigColWidth":"Table_bigColWidth__Gy2af","biggerColWidth":"Table_biggerColWidth__1ogkj","row":"Table_row__359m4","col":"Table_col__1-M7V"};